import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgbAccordion } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: "app-custom-accordian",
  templateUrl: "./custom-accordian.component.html",
  styleUrls: ["./custom-accordian.component.scss"],
})
export class CustomAccordianComponent implements OnInit {
  @ViewChild("collapseToggle") accordionComponent: NgbAccordion;
  @Input() heading: string;
  @Input() activeIds: string;
  @Input() toggleCollapse: Subject<{ id: string; toggle: boolean }>;

  constructor() {}

  ngOnInit(): void {
    this.toggleCollapse?.subscribe(
      (toggleResponse: { id: string; toggle: boolean }) => {
        if (toggleResponse.toggle) {
          this.expand(toggleResponse.id);
        } else {
          this.collapse(toggleResponse.id);
        }
        return;
      }
    );
  }

  expand(id: string) {
    this.accordionComponent.expand(id);
  }
  collapse(id: string) {
    this.accordionComponent.collapse(id);
  }
}
